module.exports = __webpack_public_path__ + "img/Arabic-12.ae861528.jpg";